import { render, staticRenderFns } from "./DesignPopup.vue?vue&type=template&id=3dd1c1ae&"
import script from "./DesignPopup.vue?vue&type=script&lang=ts&"
export * from "./DesignPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports